import { CheckCircle, Download, Loader, XCircle } from 'react-feather';
import { formatJapaneseDateTimeString } from '../../utils/dateUtils';
import { useOaCsvDownload, useOaCsvJobList } from '../../hooks/Download/useOACsvDownload';
import { formatFileSize } from '../../utils/filesize';

export const OaCsvOutputJobList = () => {
  const jobList = useOaCsvJobList();

  if (jobList?.length === 0) {
    return <div className="text-darkblue_70">国表CSV出力のリクエストがありません</div>;
  }

  return (
    <ul className="flex flex-col gap-3">
      {jobList?.map((job) => (
        <li key={job.requestId}>
          <OaCsvOutputJobCard
            requestId={job.requestId}
            status={job.status}
            totalCount={job.totalCount}
            totalCsvRows={job.totalCsvRows}
            size={job.size}
            requestedAt={job.createdAt}
            availableAt={job.completedAt}
          />
        </li>
      ))}
    </ul>
  );
};

const OaCsvOutputJobCard = ({
  requestId,
  status,
  totalCount,
  totalCsvRows,
  size,
  requestedAt,
  availableAt,
}: {
  requestId: string;
  status: 'GENERATING' | 'COMPLETED' | 'FAILED';
  totalCount: number;
  totalCsvRows: number;
  size: number | null;
  requestedAt: string;
  availableAt: string | null;
}) => {
  const { download, isPending } = useOaCsvDownload(requestId);
  return (
    <div className="w-full px-4 py-2 rounded border border-darkblue_70 flex gap-2 items-center">
      <div className="grow flex flex-col gap-1.5 text-base text-darkblue_100">
        <div className="font-bold pt-2 pb-1">
          {status === 'GENERATING' ? (
            <div className="flex items-center gap-2 text-gray-500">
              <Loader size={18} />
              <div className="">作成中...</div>
            </div>
          ) : status === 'COMPLETED' ? (
            <div className="flex items-center gap-2 text-darkblue_100">
              <CheckCircle size={18} />
              <div>作成完了</div>
            </div>
          ) : (
            <div className="flex items-center gap-2 text-error">
              <XCircle size={18} />
              <div>作成に失敗しました</div>
            </div>
          )}
        </div>
        <div>出力事案数: {totalCount}</div>
        <div>出力行数: {totalCsvRows ? totalCsvRows : "--"}</div>
        <div>ファイルサイズ: {size ? formatFileSize(size) : '--'}</div>
        <div>リクエスト日時: {formatJapaneseDateTimeString(new Date(requestedAt), 'second')}</div>
        <div>
          ダウンロード可能日時:{' '}
          {availableAt ? formatJapaneseDateTimeString(new Date(availableAt), 'second') : '--'}
        </div>
      </div>

      <button
        disabled={status !== 'COMPLETED' || isPending}
        onClick={() => download()}
        className="flex items-center gap-2 px-3 py-2 rounded bg-darkblue_100 text-white disabled:opacity-50"
      >
        <Download size={20} />
        <div className="font-bold">ダウンロード</div>
      </button>
    </div>
  );
};
